import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ProductStepper from './ProductStepper';
import ProductCardGroup from './ProductCardGroup';

import pens from '../data/pens';

import styles from '../css/app.module.css';

class ProductsOverlay extends Component {
  handleClickActionBtn = (productId, model) => {
    this.props.onClickActionBtn(productId, model);
  };

  render() {
    return (
      <div className={`${styles['products-overlay']} ${styles['disable-dbl-tap-zoom']}`}>
        <ProductStepper onClickClose={this.props.onClickClose} />

        <ProductCardGroup products={pens} onClickActionBtn={this.handleClickActionBtn} pen={this.props.pen} />
      </div>
    );
  }
}

ProductsOverlay.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  onClickActionBtn: PropTypes.func.isRequired,
};

export default ProductsOverlay;
